const RecuperaAdicionais = (dados: string): JSON => {
  if (dados === '') return JSON.parse('{}');

  const dado = dados.split('=');

  return JSON.parse(`{ "${dado[0]}": "${dado[1]}" }`);
};

export default RecuperaAdicionais;
